export { ChannelSlider } from './channel-slider';
